import React from "react";
import { useNavigate } from "react-router-dom";

const BackToRestaurant = ({ businessId, businessType, deliveryType, targetPage }) => {
  const navigate = useNavigate();

  const gotoPage = () => {
    if (targetPage === "cart") {
      if (businessId && businessId !== "undefined") {
        const type = (businessType || "restaurant").toLowerCase();
        navigate(`/${type}/${businessId}/cart`);
      } else {
        navigate(-1);
      }
      return;
    }

    const type = (businessType || "").toLowerCase();
    const tabQuery = deliveryType ? `?tab=${deliveryType}` : "";
    if (businessId && businessId !== "undefined") {
      navigate(`/${type || "restaurant"}/${businessId}${tabQuery}`);
    } else if (type === "raw_food" || type === "wholesale") {
      navigate(`/raw_food${tabQuery}`);
    } else if (type === "store" || type === "retail") {
      navigate(`/store${tabQuery}`);
    } else {
      navigate(`/${type || "restaurant"}${tabQuery}`);
    }
  };

  return (
    <div className="restaurantBack my-6 md:my-14 cursor-pointer">
      <div
        className={
          "gap-3 items-center text-white inline-flex bg-black h-2/4 px-5 py-2 rounded-xl cursor-pointer hover:bg-gray-800 transition-colors"
        }
        onClick={gotoPage}
      >
        <ion-icon name="arrow-back-circle"></ion-icon>
        Back
      </div>
    </div>
  );
};

export default BackToRestaurant;
